<template>
	<b-modal
		id="previewModal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		no-close-on-esc
	>
		<main>
			<div
				class="d-flex align-items-center justify-content-between w-100 pt-3 px-3"
			>
				<h1>Preview</h1>
				<img
					class="pointer rotate-on-hover"
					src="../../../assets/common-icons/white-cross.svg"
					alt="white-cross"
					@click="$bvModal.hide('previewModal')"
				/>
			</div>

			<hr class="hr-line" />

			<section style="background: #333" class="pl-3 pr-2 pb-3">
				<h3>Click on preview links to preview respective ports.</h3>
				<section class="body-overflow">
					<section class="grey-card">
						<b-card
							class="mt-3"
							v-for="(link, index) in previewLinks"
							:key="index"
						>
							<div class="w-30 text-one">
								Port Number:
								<strong> {{ link.port }} </strong>
							</div>
							<div class="straight-line"></div>
							<div
								class="w-70 text-two pointer"
								@click="openLink(link.tunnel_url)"
							>
								{{ link.tunnel_url }}
							</div>
						</b-card>
					</section>
				</section>
			</section>
		</main>
	</b-modal>
</template>

<script>
export default {
	name: "PreviewLinksModal",
	props: {
		previewLinks: Array,
	},
	methods: {
		openLink(url) {
			window.open(url, "_blank");
		},
	},
};
</script>

<style>
#previewModal .modal-body {
	padding: 0;
	background: #333;
	border-radius: 8px;
}

@media (min-width: 576px) {
	#previewModal .modal-dialog {
		max-width: 601px;
	}
}

#previewModal h1 {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 18px;
	line-height: 22px;
	color: #ffffff;
	margin-bottom: 0px;
}

.hr-line {
	border: 1px solid #474747;
}

#previewModal h3 {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 25px;
	color: #fcfcfc;
	margin-bottom: 0px;
}

.grey-card .card {
	background: #d9d9d91a;
	border: 1px solid #8c8c8c26;
	box-shadow: 0px 4px 5px 1px #6f6f6f2b;
}

.grey-card .card-body {
	display: flex;
	align-items: center;
	gap: 15px;
	width: 100%;
	padding: 10px;
}

.w-30 {
	width: 30%;
}

.w-70 {
	width: 70%;
}

.straight-line {
	border: 1px solid #8c8c8c66;
	height: 25px;
}

.text-one {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 130%;
	color: #d9d9d9;
}

.text-two {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	line-height: 130%;
	text-decoration-line: underline;
	color: #fcfcfc;
}

.body-bg {
	background: #333;
}

.body-overflow {
	height: calc(100vh - 565px);
	min-height: 275px;
	overflow-x: hidden;
	overflow-y: auto;
	background: inherit;
	padding-right: 6px;
}
</style>
